<template>
  <div
    id="app"
  >
    <HeaderBar
      v-show="!coverVideoFlag || fromWidgetFlag.flag"
      pageName="memory"
    />
    <CollectorCover
      v-if="coverVideoFlag && !fromWidgetFlag.flag"
      srcMob="https://p3.udn.com.tw/memory_collector/cover_video_mob.mp4"
      srcWeb="https://p3.udn.com.tw/memory_collector/cover_video_web.mp4"
      posterMob="images/opening_poster_mob.jpg"
      posterWeb="images/opening_poster_web.jpg"
    >
    </CollectorCover>
    <MemoryGallery
      v-if="!coverVideoFlag"
      :key="memoryGalleryKey"
      :completedFlag="completedFlag"
    />



    <!-- <MemoryGallery
      v-if="!coverVideoFlag && !writeMailFlag"
      :key="memoryGalleryKey"
      :completedFlag="completedFlag"
    />
    <WriteMail
      v-if="writeMailFlag"
    /> -->





    
    <LogoAndEditorMob
      v-if="isMob && !coverVideoFlag && !writeMailFlag ||
      isMob && fromWidgetFlag.flag && fromWidgetFlag.endFlag"
    ></LogoAndEditorMob>
    <LogoAndEditor
      v-if="!isMob && !coverVideoFlag && !writeMailFlag ||
      !isMob && fromWidgetFlag.flag && fromWidgetFlag.endFlag"
    ></LogoAndEditor>
    <div v-show="completedFlag" class="share-hint-message-wrapper">
      <div class="share-hint-message">
        信件已寄出。是否要和朋友分享你的921記憶？
        <div class="share-button-wrapper">
          <div class="share-button" @click="shareFacebook()"><img src="images/fb_share.svg" alt="fb_share"></div>
          <div class="share-button" @click="shareLine()"><img src="images/line_share.svg" alt="line_share"></div>
        </div>
        <div class="share-hint-button-wrapper">
          <button name="share-hint-button" class="share-hint-button" @click="completedFlag = false">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils';

import HeaderBar from '../../general_components/HeaderBar.vue';
// import HeaderBar from './components/HeaderBar.vue';
import LogoAndEditor from './components/LogoAndEditor.vue';
import LogoAndEditorMob from './components/LogoAndEditorMob.vue';
import CollectorCover from './components/CollectorCover.vue';
import MemoryGallery from './components/MemoryGallery.vue';
import SharePanel from './components/SharePanel.vue';
import WriteMail from './components/WriteMail.vue';

export default {
  name: 'MainApp',
  components: {
    HeaderBar,
    LogoAndEditor,
    LogoAndEditorMob,
    CollectorCover,
    MemoryGallery,
    SharePanel,
    WriteMail,
  },
  data() {
    return {
      fromWidgetFlag: {
        flag: false,
        endFlag: false,
      },
      coverVideoFlag: true,
      writeMailFlag: false,
      completedFlag: false,
      memoryGalleryKey: 0,
      href: 'https://udn.com/newmedia/921/memory/',
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 1024 ? true : false;
    },
    isFromWidget() {
      return this.$router.history.current.fullPath === '/2' ? true : false;
    },
  },
  methods: {
    skipVideo() {
      this.coverVideoFlag = !this.coverVideoFlag;
    },
    changeFromWidgetFlag() {
      this.coverVideoFlag = false;
      this.fromWidgetFlag.endFlag = !this.fromWidgetFlag.endFlag;
    },
    changeWriteMailFlag() {
      this.writeMailFlag = !this.writeMailFlag;
    },
    changeCompletedFlag() {
      this.completedFlag = !this.completedFlag;
    },
    shareFacebook() {
      window.FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': 'https://udn.com/newmedia/921/memory/',
            'og:title': '寫一封信給921 | 專題 | 聯合報',
            'og:description': '921那日，你是怎麼度過的？我們想邀請你，寫一封信給921。',
            'og:image': 'https://udn.com/newmedia/921/memory/images/meta.jpg',
          },
        }),
      });
      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [${document.querySelector('title').innerHTML}] [特製fb icon] [fb share]`,
      });
      this.completedFlag = false;
    },
    shareLine() {
      if (Utils.detectMob()) {
        // 手機
        window.location.assign(`https://line.me/R/msg/text/?${document.querySelector('title').innerHTML}%0D%0A%0D%0A${document.querySelector('meta[property="og:description"]').content}%0D%0A%0D%0A${this.href}`);
      } else {
        window.open(`https://line.me/R/msg/text/?${document.querySelector('title').innerHTML}%0D%0A%0D%0A${document.querySelector('meta[property="og:description"]').content}%0D%0A%0D%0A`);
      }
      window.ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}] [${document.querySelector('title').innerHTML}] [特製line icon] [line share]`,
      });
      this.completedFlag = false;
    },
    forceRerenderMemoryGallery() {
      this.memoryGalleryKey += 1;
    },
  },
  created() {
    if (window.location.hash === '#/2') {
      this.fromWidgetFlag.flag = true;
      this.writeMailFlag = true;
    }
  },
};
</script>

<style lang="scss">
  body {
    background-color: #f1f1f1;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
    outline: none !important;
  }

  .fly-in-1 {
    animation-name: flyIn;
    animation-timing-function: cubic-bezier(.89,1.4,.68,.94);
    animation-duration: 0.9s;
  }

  .fly-in-2 {
    animation-name: flyIn;
    animation-timing-function: cubic-bezier(.89,1.4,.68,.94);
    animation-duration: 1.2s;
  }

  .fly-in-3 {
    animation-name: flyIn;
    animation-timing-function: cubic-bezier(.89,1.4,.68,.94);
    animation-duration: 1.3s;
  }

  .fly-in-1-delay {
    animation-name: flyIn;
    animation-timing-function: cubic-bezier(.89,1.4,.68,.94);
    animation-delay: 1s;
    animation-duration: 0.9s;
  }
  .fly-in-2-delay {
    animation-name: flyIn;
    animation-timing-function: cubic-bezier(.89,1.4,.68,.94);
    animation-delay: 1s;
    animation-duration: 1.3s;
  }

  @keyframes flyIn {
    0% {
      opacity: 0;
      transform: translateY(70vh);
    }
    30% {
      opacity: 0;
      transform: translateY(70vh);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .share-hint-message-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .share-hint-message {
      position: relative;
      width: 80vw;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 50px 20px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px #57b09f;
      background-color: #dedede;
      @media only screen and (min-width: 1024px) {
        width: 40vw;
      }
      .share-button-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        .share-button {
          margin: 5px;
          cursor: pointer;
        }
      }
      .share-hint-button-wrapper {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 10px;
        @media only screen and (min-width: 1024px) {
          margin: 20px;
        }
        .share-hint-button {
          padding: 5px 10px;
          border-radius: 2px;
          border: solid 1px #707070;
          background-color: #dedede;
          color: #707070;
          @media only screen and (min-width: 1024px) {
            padding: 10px 15px;
          }
        }
      }
    }
  }
</style>
